var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mine-page" }, [
    _c("header", { staticClass: "mine-hero" }, [
      _c("div", { staticClass: "mine-avatar" }, [
        _vm._v(_vm._s(_vm.avatarText)),
      ]),
      _c("div", { staticClass: "mine-name" }, [
        _vm._v(_vm._s(_vm.displayName)),
      ]),
      _c("div", { staticClass: "mine-sub" }, [_vm._v(_vm._s(_vm.subTitle))]),
    ]),
    _c("main", { staticClass: "mine-body" }, [
      _c(
        "section",
        { staticClass: "mine-card" },
        _vm._l(_vm.entries, function (item) {
          return _c(
            "div",
            {
              key: item.text,
              staticClass: "mine-row",
              on: {
                click: function ($event) {
                  return _vm.handleGo(item.path)
                },
              },
            },
            [
              _c("span", {
                staticClass: "row-ico",
                domProps: { innerHTML: _vm._s(item.icon) },
              }),
              _c("span", { staticClass: "row-text" }, [
                _vm._v(_vm._s(item.text)),
              ]),
              _c("span", { staticClass: "row-tip" }, [
                _vm._v(_vm._s(item.tip)),
              ]),
              _c("span", { staticClass: "row-arrow" }, [_vm._v("›")]),
            ]
          )
        }),
        0
      ),
      _c("section", { staticClass: "mine-card" }, [
        _c(
          "div",
          {
            staticClass: "mine-row",
            on: {
              click: function ($event) {
                _vm.showAbout = true
              },
            },
          },
          [
            _c("span", {
              staticClass: "row-ico",
              domProps: { innerHTML: _vm._s(_vm.ICONS.info) },
            }),
            _c("span", { staticClass: "row-text" }, [_vm._v("关于")]),
            _c("span", { staticClass: "row-tip" }, [
              _vm._v("v" + _vm._s(_vm.version)),
            ]),
            _c("span", { staticClass: "row-arrow" }, [_vm._v("›")]),
          ]
        ),
      ]),
      _c("p", { staticClass: "mine-foot" }, [
        _vm._v("© 版权所有 鄂ICP备2020017212号-1"),
      ]),
    ]),
    _vm.showAbout
      ? _c(
          "div",
          {
            staticClass: "about-mask",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                _vm.showAbout = false
              },
            },
          },
          [
            _c("div", { staticClass: "about-box" }, [
              _c("p", { staticClass: "about-title" }, [_vm._v("简录学业")]),
              _c("p", { staticClass: "about-ver" }, [
                _vm._v("v" + _vm._s(_vm.version)),
              ]),
              _c("p", { staticClass: "about-text" }, [
                _vm._v("学习记录 · 成绩曲线 · 信箱"),
              ]),
              _c("p", { staticClass: "about-text" }, [
                _vm._v("© 鄂ICP备2020017212号-1"),
              ]),
              _c(
                "button",
                {
                  staticClass: "about-btn",
                  on: {
                    click: function ($event) {
                      _vm.showAbout = false
                    },
                  },
                },
                [_vm._v("知道了")]
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }